import React from 'react'

export const ArrowRightSVG: React.VFC<{
  className?: string
  width?: number
  height?: number
}> = ({ className, width = 20, height = 20 }) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.16669 10H15.8334M15.8334 10L10 4.16667M15.8334 10L10 15.8333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
